<script setup lang="ts">
import { computed, watch } from 'vue'

type PasswordCriterionName = 'minLength' | 'capitalLetters' | 'lowercaseLetters' | 'digits'

const config: { name: PasswordCriterionName, regex: RegExp }[] = [
  {
    name: 'minLength',
    regex: /(.){8}/g
  },
  {
    name: 'capitalLetters',
    regex: /([A-ZÄÜÖ])/g
  },
  {
    name: 'lowercaseLetters',
    regex: /([a-zäöü])/g
  },
  {
    name: 'digits',
    regex: /([0-9])/g
  }
]

const criteriaWording: Record<PasswordCriterionName, string> = {
  minLength: 'Mindestens 8 Zeichen',
  capitalLetters: 'Großbuchstaben',
  lowercaseLetters: 'Kleinbuchstaben',
  digits: 'Ziffern'
}

const props = withDefaults(defineProps<{
  password?: string
}>(), {
  password: ''
})

const emit = defineEmits<{
  (e: 'valid', value: boolean): void
}>()

const passwordCriteria = computed(() => {
  return config.map(rule => {
    return {
      name: rule.name,
      valid: !!(props.password)?.match(rule.regex)
    }
  })
})

watch(passwordCriteria, () => {
  emit('valid', passwordCriteria.value.every(criteria => criteria.valid))
})
</script>

<template>
  <div class="bx-form__pass-criteria">
    <span v-for="criteria in passwordCriteria"
          :key="criteria.name"
          :class="{'bx-js-checked': criteria.valid}">
      <span class="icon icon-check">
        <svg><use href="#check" /></svg>
      </span>
      {{ criteriaWording[criteria.name] }}
    </span>
  </div>
</template>
